import { render, staticRenderFns } from "./warehouse_area_code.vue?vue&type=template&id=404f813d&scoped=true&"
import script from "./warehouse_area_code.vue?vue&type=script&lang=js&"
export * from "./warehouse_area_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f813d",
  null
  
)

export default component.exports